var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotauthorizedlarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2803 60.3899L30.5503 54.45L61.3503 72.2399L51.0903 78.1699L20.2803 60.3899Z",
    fill: "url(#paint0_linear_1432_361934)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1597 32.8999C61.0385 32.6907 60.8666 32.5153 60.6597 32.3899L59.5597 31.7499L31.0797 15.3099C31.0083 15.2584 30.9249 15.2259 30.8374 15.2154C30.75 15.2049 30.6613 15.2168 30.5797 15.2499L20.4697 21.0799C20.3597 21.1499 22.6297 49.8499 22.6297 49.8499L26.9297 52.6399L61.2597 33.0999C61.2325 33.0304 61.199 32.9635 61.1597 32.8999Z",
    fill: "url(#paint1_linear_1432_361934)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1597 62.4501C61.2393 62.3999 61.3032 62.3282 61.3439 62.2432C61.3846 62.1583 61.4004 62.0636 61.3897 61.9701V33.6401C61.3834 33.4531 61.3392 33.2694 61.2597 33.1001L26.9297 52.6401L51.0497 68.2801L61.1597 62.4501Z",
    fill: "url(#paint2_linear_1432_361934)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1597 62.4501C61.2393 62.3999 61.3032 62.3282 61.3439 62.2432C61.3846 62.1583 61.4004 62.0636 61.3897 61.9701V33.6401C61.3834 33.4531 61.3392 33.2694 61.2597 33.1001L26.9297 52.6401L51.0497 68.2801L61.1597 62.4501Z",
    fill: "url(#paint3_linear_1432_361934)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8796 31.3999C46.8948 31.5488 46.9491 31.691 47.0369 31.8121C47.1247 31.9333 47.2429 32.0291 47.3796 32.0899C47.7537 32.2773 48.1662 32.3749 48.5846 32.3749C49.003 32.3749 49.4156 32.2773 49.7896 32.0899C49.9258 32.0269 50.0429 31.9289 50.129 31.806C50.215 31.683 50.267 31.5395 50.2796 31.3899V18.2699C50.2796 12.8799 46.1296 6.26994 40.8196 3.19994C37.8196 1.43994 34.8196 1.19994 32.5996 2.41994C30.6996 3.50994 29.5996 5.60994 29.5996 8.30994V21.4999C29.6132 21.6505 29.6666 21.7948 29.7545 21.9179C29.8424 22.0409 29.9615 22.1383 30.0996 22.1999C30.4719 22.3872 30.8829 22.4848 31.2996 22.4848C31.7164 22.4848 32.1273 22.3872 32.4996 22.1999C32.6365 22.1366 32.7545 22.0388 32.8422 21.9161C32.9298 21.7933 32.9841 21.6499 32.9996 21.4999V8.30994C32.945 7.748 33.0359 7.18145 33.2635 6.6648C33.4912 6.14815 33.848 5.69879 34.2996 5.35994C35.3796 4.73994 37.1796 5.02994 39.1196 6.14994C43.3296 8.57994 46.8796 14.1499 46.8796 18.2699V31.3999Z",
    fill: "url(#paint4_linear_1432_361934)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5604 38.2199L49.4604 37.5899L21.0004 21.1399C20.931 21.0795 20.8444 21.0423 20.7528 21.0337C20.6613 21.025 20.5692 21.0453 20.4898 21.0917C20.4103 21.138 20.3474 21.2081 20.3098 21.2921C20.2723 21.3761 20.262 21.4698 20.2804 21.5599V49.8899C20.2905 50.1525 20.3698 50.4078 20.5104 50.6299C20.6281 50.8385 20.7967 51.0139 21.0004 51.1399L49.4604 67.5899L50.5604 68.2199C50.6299 68.2714 50.7116 68.3041 50.7975 68.3146C50.8834 68.3251 50.9705 68.3131 51.0504 68.2799C51.1292 68.2313 51.1927 68.1613 51.2334 68.0782C51.2741 67.995 51.2904 67.902 51.2804 67.8099V39.4699C51.2659 39.2199 51.1932 38.9767 51.0682 38.7597C50.9432 38.5427 50.7694 38.3579 50.5604 38.2199Z",
    fill: "url(#paint5_linear_1432_361934)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0002 41.63C37.9563 40.8492 37.7298 40.0897 37.3391 39.4124C36.9483 38.735 36.4041 38.1588 35.7502 37.73C34.5002 37.01 33.4902 37.6 33.4902 39.03C33.5275 39.9261 33.8189 40.7931 34.3302 41.53L33.4902 46.84L38.0002 49.44L37.1602 43.17C37.4461 43.0364 37.6819 42.8149 37.833 42.5378C37.9841 42.2608 38.0427 41.9427 38.0002 41.63Z",
    fill: "url(#paint6_linear_1432_361934)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4097 38.51C51.2523 38.2446 51.0327 38.0215 50.7697 37.86L49.6697 37.23L21.1797 20.78L21.0797 20.73L20.4697 21.08C20.5254 21.0651 20.584 21.0651 20.6397 21.08C20.7537 21.0822 20.8647 21.1169 20.9597 21.18L49.4597 37.59L50.5597 38.22C50.7614 38.3485 50.9294 38.5234 51.0497 38.73C51.0497 38.73 51.0997 38.82 51.1297 38.87L51.4897 38.66L51.4097 38.51Z",
    fill: "url(#paint7_linear_1432_361934)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1432_361934",
    x1: 27.9803,
    y1: 73.7199,
    x2: 53.6503,
    y2: 58.8999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1432_361934",
    x1: 17.3297,
    y1: 40.6799,
    x2: 53.5697,
    y2: 19.7599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1432_361934",
    x1: 28.5897,
    y1: 16.0101,
    x2: 58.8797,
    y2: 68.4701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8D8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1432_361934",
    x1: 26.9297,
    y1: 50.6901,
    x2: 61.3897,
    y2: 50.6901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1432_361934",
    x1: 856.179,
    y1: 996.22,
    x2: 856.179,
    y2: 52.0327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1432_361934",
    x1: 24.5804,
    y1: 44.6799,
    x2: 51.6204,
    y2: 44.6799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1432_361934",
    x1: 32.7202,
    y1: 45.46,
    x2: 38.8202,
    y2: 41.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8D8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1432_361934",
    x1: 20.6097,
    y1: 20.85,
    x2: 52.6997,
    y2: 39.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FDFDFD",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FBFBFB",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F7F7F7",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3F3F3",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EDEDED",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#E6E6E6",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#DFDFDF",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D6D6D6",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotauthorizedlarge);
export default __webpack_public_path__ + "static/media/Not authorized large.584b1378a38f61566464bc58ea7eb20a.svg";
export { ForwardRef as ReactComponent };